module.exports = __webpack_public_path__ + "Crest.f8ca78e.png";